<template>
  <div>
    <el-select v-model="selectValue">
      <el-option
          v-for="item in selectData"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import {
  businessDescriptionData,
  businessDescriptionABData,
} from '../../common-data/config.js';

export default {
  name: "BusinessDescrption",

  props: {
    value: {
      type: String,
      default: '',
    },
    agencyBanking: {
      type: Boolean,
      default: false,
    },
    busiNature: {
      type: String,
      default: '',
    },
  },

  data() {
    // console.log(businessNatureABData, businessNatureData)
    const initBusiNature = this.busiNature // || (this.agencyBanking ? businessNatureABData : businessNatureData)[0].value;
    // 如果busiNature为空值 说明busiDescript下拉列表还为确定
    const services = initBusiNature ? (this.agencyBanking ? businessDescriptionABData : businessDescriptionData)[initBusiNature].services : [];
    return {
      selectValue: "",
      selectData: services,
    }
  },

  watch: {
    busiNature(newValue) {
      const services = (this.agencyBanking ? businessDescriptionABData : businessDescriptionData)[newValue].services;
      this.selectData = services;
      this.selectValue = services[0].value;
    },
    value(newValue) {
      this.selectValue = newValue;
    },
    selectValue(newValue) {
      this.$emit("input", newValue);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>